//分页加载
export async function loadingFun(
  fun,
  page,
  dataList = [],
  loading,
  params = {}
) {
  // 拷贝对象
  dataList = Object.assign([], dataList);
  // console.log(page)
  if (loading == false) return false;
  const { code, data } = await fun({
    currentPage: page,
    ...params,
  });
  console.log(data);

  if (code == 0) {
    let { records } = data;
    dataList.push(...records);
    page = ++page;
    if (params.pageSize) {
      if (records.length < params.pageSize) {
        loading = false;
      }
    }
    if (dataList.length <= 0) {
      loading = false;
    }
  } else {
    loading = false;
  }
  return {
    page,
    dataList,
    loading,
  };
}

/**
 * 生成guid
 * @param len 长度
 * @param firstU 添加 U 前缀
 * @param radix
 * @return {string}
 */
export function guid(len = 32, firstU = true, radix = null) {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  const uuid = [];
  radix = radix || chars.length;

  if (len) {
    // 如果指定uuid长度,只是取随机的字符,0|x为位运算,能去掉x的小数位,返回整数位
    for (let i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;
    // rfc4122标准要求返回的uuid中,某些位为固定的字符
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  // 移除第一个字符,并用u替代,因为第一个字符为数值时,该guid不能用作id或者class
  if (firstU) {
    uuid.shift();
    return "u" + uuid.join("");
  } else {
    return uuid.join("");
  }
}

/**
 * 过滤空值
 * @param obj
 * @return {string}
 */
export const filterNonEmptyFieldsByStr = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    console.log("Expected an object");
    return "";
  }

  const result = [];
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, "key")) {
      const value = obj[key];
      // 判断值是否为空
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) &&
        !(
          typeof value === "object" &&
          value !== null &&
          Object.keys(value).length === 0
        )
      ) {
        result[key] = value;
        result.push(key + "=" + value);
      }
    }
  }
  return result.join("&");
};

/**
 * 字符串是否为空
 * @param value 字符串
 */
export function isEmptyString(value) {
  return !value || value.trim() === "";
}

/**
 * 字符串是否不为空
 * @param value 字符串
 */
export function isNotEmptyString(value) {
  return !isEmptyString(value);
}

/**
 * 获取不为空的字符串
 * @param value 字符串
 * @param defaultValue 默认值
 */
export function getNotEmptyString(value, defaultValue) {
  return isNotEmptyString(value) ? value : defaultValue;
}

export function isValidDateYMD(dateStr) {
  const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
  return regex.test(dateStr);
}

/**
 * 格式化日期
 * @param dateStr 数据源
 * @return {*|string}
 */
export function formatDate(dateStr) {
  if (isEmptyString(dateStr) || dateStr.length < 8) {
    return dateStr;
  }
  const year = dateStr.substring(0, 4);
  const month = dateStr.substring(4, 6);
  const day = dateStr.substring(6, 8);
  return `${year}-${month}-${day}`;
}

export function replaceChineseDate(dateStr, replacement) {
  const reg = /(\w*)年(.*)月(.*)日(.*)/g;
  return dateStr.replace(reg, replacement);
}

export function floorToOneDecimalPlace(number) {
  return Math.floor(number * 10) / 10;
}

export const isOpenPaymentRouter = () => {
  return routerConfig.type === 0;
};

const routerConfig = {
  type: 0,
};
